module.exports = __webpack_public_path__ + "img/img6.642b4bd9.jpg";